import { ProductType } from 'constants.js';
import { constants } from 'views/Campaign';

const {
  campaignOccurrenceTypes: {
    ON_EVENT,
    SCHEDULED,
    ON_DEMAND,
    INTERNAL_SURVEY_RESPONSE,
    EXTERNAL_SURVEY_RESPONSE
  }
} = constants;

class CurrentAttachment {
  constructor(attachment, thisAttachmentUuid, thisCampaign) {
    this.isEventTypeScheduled = attachment.campaignOccurrenceType === SCHEDULED;
    this.isEventTypeOnDemand = attachment.campaignOccurrenceType === ON_DEMAND;
    this.isEventType = attachment.campaignOccurrenceType === ON_EVENT;
    this.isEventTypeInternalSurveyResponse =
      attachment.campaignOccurrenceType === INTERNAL_SURVEY_RESPONSE;
    this.isEventTypeExternalSurveyResponse =
      attachment.campaignOccurrenceType === EXTERNAL_SURVEY_RESPONSE;

    this.isAlreadyAssigned = attachment.uuid === thisAttachmentUuid;

    this.isEventTypeSameAsCampaign =
      attachment.schemaIdentifier === thisCampaign.schemaIdentifier;

    this.isActive = attachment.active;

    this.isValidListTemplate =
      (attachment.productType !== ProductType.List &&
        thisCampaign.productType !== ProductType.List) ||
      attachment.subscriberListId === thisCampaign.subscriberListId;

    this.isPromotionalMatch = thisCampaign.promotional ? attachment.promotional === true : true;

    this.isSurveyResponseTemplate = attachment.surveyResponseTemplate === true;
  }
}

export default (attachmentsList = [], thisAttachmentUuid, thisCampaign) => {
  let results = [];
  if (thisCampaign.campaignOccurrenceType === ON_DEMAND) {
    results = attachmentsList.filter(attachment => {
      const currentAttachment = new CurrentAttachment(
        attachment,
        thisAttachmentUuid,
        thisCampaign
      );
      return (
        currentAttachment.isEventTypeOnDemand &&
        currentAttachment.isEventTypeSameAsCampaign &&
        (currentAttachment.isActive || currentAttachment.isAlreadyAssigned) &&
        currentAttachment.isValidListTemplate &&
        currentAttachment.isPromotionalMatch
      );
    });
  }

  if (thisCampaign.campaignOccurrenceType === SCHEDULED) {
    results = attachmentsList.filter(attachment => {
      const currentAttachment = new CurrentAttachment(
        attachment,
        thisAttachmentUuid,
        thisCampaign
      );
      return (
        currentAttachment.isEventTypeScheduled &&
        currentAttachment.isEventTypeSameAsCampaign &&
        (currentAttachment.isActive || currentAttachment.isAlreadyAssigned) &&
        currentAttachment.isPromotionalMatch
      );
    });
  }

  if (thisCampaign.campaignOccurrenceType === INTERNAL_SURVEY_RESPONSE) {
    results = attachmentsList.filter(attachment => {
      const currentAttachment = new CurrentAttachment(
        attachment,
        thisAttachmentUuid,
        thisCampaign
      );
      return (
        currentAttachment.isEventTypeInternalSurveyResponse &&
        currentAttachment.isEventTypeSameAsCampaign &&
        (currentAttachment.isActive || currentAttachment.isAlreadyAssigned) &&
        currentAttachment.isPromotionalMatch &&
        currentAttachment.isSurveyResponseTemplate
      );
    });
  }

  if (thisCampaign.campaignOccurrenceType === EXTERNAL_SURVEY_RESPONSE) {
    results = attachmentsList.filter(attachment => {
      const currentAttachment = new CurrentAttachment(
        attachment,
        thisAttachmentUuid,
        thisCampaign
      );
      return (
        currentAttachment.isEventTypeExternalSurveyResponse &&
        currentAttachment.isEventTypeSameAsCampaign &&
        (currentAttachment.isActive || currentAttachment.isAlreadyAssigned) &&
        currentAttachment.isPromotionalMatch &&
        currentAttachment.isSurveyResponseTemplate
      );
    });
  }

  if (thisCampaign.campaignOccurrenceType === ON_EVENT) {
    results = attachmentsList.filter(attachment => {
      const currentAttachment = new CurrentAttachment(
        attachment,
        thisAttachmentUuid,
        thisCampaign
      );
      return (
        currentAttachment.isEventType &&
        currentAttachment.isEventTypeSameAsCampaign &&
        (currentAttachment.isAlreadyAssigned || currentAttachment.isActive) &&
        currentAttachment.isPromotionalMatch
      );
    });
  }

  return results;
};
